import { RootState } from '@reducers';

export const selectDashboardPageReducer = (state: RootState) => state.userDashboardRouteReducer.dashboardPageReducer;
